import React from 'react';
import { getIn, FieldProps } from 'formik';

import InlineTextField, {
  Props as InlineTextFieldProps,
} from '../InlineTextField';

//------------------------------------------------------------------------------
// Types
//------------------------------------------------------------------------------

type Props = FieldProps & Omit<InlineTextFieldProps, 'name' | 'value'>;

//------------------------------------------------------------------------------
// Component
//------------------------------------------------------------------------------

function fieldToInlineTextField({
  disabled,
  field: { onBlur: fieldOnBlur, ...field },
  form: { isSubmitting, touched, errors },
  onBlur,
  helperText,
  ...props
}: Props): InlineTextFieldProps {
  const fieldError = getIn(errors, field.name);
  const showError = getIn(touched, field.name) && !!fieldError;

  return {
    disabled: disabled ?? isSubmitting,
    error: showError,
    helperText: showError ? fieldError : helperText,
    onBlur:
      onBlur ??
      function (e) {
        fieldOnBlur(e ?? field.name);
      },
    ...field,
    ...props,
  };
}

/**
 * ImageUploader uploads the image selected with and ImageSelect and it for
 * Formik.
 */
export default function InlineTextFieldAdapter(props: Props) {
  return <InlineTextField {...fieldToInlineTextField(props)} />;
}
